type PhotoPreviewProps = {
	photo: string;
	onClear: () => void;
	onCreate: (val: string) => void;
};

export function PhotoPreview({ photo, onClear, onCreate }: PhotoPreviewProps) {
	const handleCreate = () => {
		onCreate(photo);
	};

	return (
		<div className="photo-preview">
			<img src={photo} alt="photo" />
			<div className="buttons">
				<button className="btn btn--primery" onClick={onClear}>
					Сделать другое фото
				</button>
				<button className="btn btn--primery" onClick={handleCreate}>
					Отправить фото
				</button>
			</div>
		</div>
	);
}
